var e, i;
function n() {
  if (i) return e;
  i = 1;
  function t(r) {
    return r != null && typeof r == "object";
  }
  return e = t, e;
}
export {
  n as __require
};
